/**
 */
import metrics from '../services/metrics';
import config from './internetConfig';

const internetMetrics = metrics(config);

export default internetMetrics;
